module.exports = __webpack_public_path__ + "static/media/up.bf355233.svg";